// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1wCbv","savePackageButton":"ClientWallet_savePackageButton__2pj7W"};